module.exports = __webpack_public_path__ + "static/Lato-Regular-2d36b1a925432bae7f3c53a340868c6e.ttf";